import { render, staticRenderFns } from "./AbkLoginHeader.vue?vue&type=template&id=c21dbe50&scoped=true&"
import script from "./AbkLoginHeader.vue?vue&type=script&lang=js&"
export * from "./AbkLoginHeader.vue?vue&type=script&lang=js&"
import style0 from "./AbkLoginHeader.vue?vue&type=style&index=0&id=c21dbe50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21dbe50",
  null
  
)

export default component.exports